import { UserManager, WebStorageStateStore } from "oidc-client-ts";

import { config } from "./config";

export const userManager = new UserManager({
  authority: config.authority,
  client_id: config.clientId,
  redirect_uri: config.redirectUri,
  post_logout_redirect_uri: config.postLogoutRedirectUri,
  response_type: "code",
  scope: "openid profile email",
  loadUserInfo: true,
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  monitorSession: true,
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

let renewalInFlight: ReturnType<UserManager["signinSilent"]> | null = null;

export function renewAccessToken() {
  if (!renewalInFlight) {
    renewalInFlight = userManager.signinSilent().finally(() => {
      renewalInFlight = null;
    });
  }
  return renewalInFlight;
}
